import styled from "styled-components";
import { Grid } from "@material-ui/core";

export const StyledGrid = styled(Grid)`
    ${({ theme }) => `
    margin-top: ${theme.spacing(4)}px;
    margin-bottom: ${theme.spacing(2)}px;
`}
`;
